import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useContagemTempo } from '../hooks/useContagemTempo';

const Logout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { pararTodasContagens } = useContagemTempo();

  useEffect(() => {
    const handleLogout = async () => {
      try {
        const accessToken = localStorage.getItem('access');
        
        // Determinar o tipo de logout
        const isInactivityLogout = location.state?.inactivity || false;
        
        console.log('Iniciando logout...', isInactivityLogout ? '(por inatividade)' : '(manual)');
        
        // Parar todas as contagens ativas
        try {
          await pararTodasContagens();
          console.log('Contagens paradas com sucesso');
        } catch (error) {
          console.error('Erro ao parar contagens:', error);
        }

        // Parar o tempo-no-cliente do BPO (widget flutuante) — melhor esforço
        if (accessToken) {
          try {
            await Promise.all(['RH', 'FIN'].map((area) =>
              fetch(`${process.env.REACT_APP_API_BASE}/api/bpo/tempo-cliente/`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${accessToken}`
                },
                body: JSON.stringify({ area, acao: 'parar' })
              })));
            localStorage.removeItem('bpoTempoClienteAtivo');
            console.log('Tempo-no-cliente BPO parado');
          } catch (error) {
            console.error('Erro ao parar tempo BPO:', error);
          }
        }
        
        // Registrar o logout no backend
        if (accessToken) {
          try {
            await fetch(`${process.env.REACT_APP_API_BASE}/api/register-logout/`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${accessToken}`
              },
              body: JSON.stringify({
                motivo: isInactivityLogout ? 'inatividade' : 'manual',
                timestamp: new Date().toISOString(),
                refresh: localStorage.getItem('refresh')  // D-03: backend invalida o refresh
              })
            });
            console.log('Logout registrado no backend');
          } catch (error) {
            console.error('Erro ao registrar logout:', error);
          }
        }

        // Limpar localStorage
        localStorage.removeItem('access');
        localStorage.removeItem('refresh');
        localStorage.removeItem('firstName');
        localStorage.removeItem('animacaoAtual');
        
        console.log('localStorage limpo');

        // Pequeno delay para garantir que tudo foi processado
        setTimeout(() => {
          navigate('/login', { replace: true });
        }, 500);

      } catch (error) {
        console.error('Erro geral durante logout:', error);
        
        // Mesmo com erro, garantir que o usuário seja deslogado
        localStorage.clear();
        navigate('/login', { replace: true });
      }
    };

    handleLogout();
  }, [navigate, location.state, pararTodasContagens]);

  return (
    <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
      <div className="text-center">
        <div className="spinner-border text-primary mb-3" role="status">
          <span className="visually-hidden">Carregando...</span>
        </div>
        <p className="text-muted">
          {location.state?.inactivity ? 
            'Sessão expirada por inatividade. Redirecionando...' : 
            'Fazendo logout...'
          }
        </p>
      </div>
    </div>
  );
};

export default Logout;